import EzController from 'controllers/ez-base-controller';
import { MULTIPLE_LOGIN_TRIGGERED, MULTIPLE_LOGIN_COMPLETE } from 'components/analytics/conversions/constants/actions';
import { sendTrackingEvent } from 'components/analytics/conversions/tracking';

export default class TeamsNagController extends EzController {
  declare readonly typeValue:string;

  static values = {
    type: String,
  }

  connect() {
    sendTrackingEvent({
      element: this.element as HTMLElement,
      data: {
        action: MULTIPLE_LOGIN_TRIGGERED,
        category: 'Trigger-Multiple_Login',
        label: `Display-${this.typeValue}`,
        non_interaction: true,
      },
    });
  }

  createTeamLinkClick = (event) => {
    sendTrackingEvent({
      element: event.currentTarget,
      data: {
        action: MULTIPLE_LOGIN_COMPLETE,
        category: 'Trigger-Multiple_Login',
      },
    });
  }
}
